import React from 'react';
import { Settings, Video } from 'lucide-react';

const EngineCustomization = () => {
  const services = [
    'Custom Training and enablement development',
    'Role-specific Training paths',
    'White-labeled environments',
    'Dedicated onboarding support'
  ];

  return (
    <section className="py-20 px-6">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold mb-4 text-white">
            Customization & <span className="text-cyan-400">Media Support</span>
          </h2>
          <p className="text-xl text-gray-300">
            For organizations seeking deeper enablement, Traain offers optional enterprise services:
          </p>
        </div>

        <div className="max-w-4xl mx-auto space-y-6">
          {/* Enterprise Services */}
          <div className="p-8 rounded-2xl bg-gradient-to-br from-gray-800/50 to-gray-900/50 border border-gray-700/50">
            <div className="flex items-start gap-4 mb-6">
              <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-cyan-500/20 to-blue-500/20 flex items-center justify-center flex-shrink-0">
                <Settings className="w-6 h-6 text-cyan-400" />
              </div>
              <h3 className="text-xl font-bold text-white">Enterprise Services</h3>
            </div>
            
            <div className="space-y-3 ml-16">
              {services.map((service, index) => (
                <div key={index} className="flex items-start gap-3">
                  <div className="w-2 h-2 bg-cyan-400 rounded-full mt-2 flex-shrink-0" />
                  <span className="text-gray-300">{service}</span>
                </div>
              ))}
            </div>
          </div>

          {/* Media Production */}
          <div className="p-8 rounded-2xl bg-gradient-to-br from-purple-900/30 to-blue-900/30 border border-purple-500/30">
            <div className="flex items-start gap-4 mb-4">
              <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-purple-500/20 to-blue-500/20 flex items-center justify-center flex-shrink-0">
                <Video className="w-6 h-6 text-purple-400" />
              </div>
              <div>
                <p className="text-sm text-purple-400 font-semibold uppercase tracking-wide mb-1">Optional</p>
                <h3 className="text-xl font-bold text-white">Professional Media Production</h3>
              </div>
            </div>
            
            <p className="text-gray-300 ml-16">
              Studio-level video produced by Traain's media team to create high-quality Training content.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default EngineCustomization;
